// extracted by mini-css-extract-plugin
module.exports = {"btn":"d_bb"};